import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Input, Form,FormFeedback} from 'reactstrap';

const ImageModal = ({modal,setModal}) => {
	
    return (
		<div>
	        <Modal isOpen={modal.show} size='xl'>
				<ModalHeader className="bg-primary">{modal.title}</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12" style={{textAlign: 'center'}}>
							<img
								src={modal.url}
								alt=""
								style={{width:"730px",height:"580px",}}
							/>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={()=>setModal({...modal,show:false})}>Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default ImageModal;